import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, ConsultaConsumidor } from './types';

export const INITIAL_STATE: ConsultaConsumidor = {
	status: 0,
	data: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): ConsultaConsumidor {
	return produce(state, draft => {
		switch (action.type) {
			case Types.CONSULTA_CONSUMIDOR_REQUEST: {
				break;
			}
			case Types.CONSULTA_CONSUMIDOR_SUCCESS: {
				draft.status = 200;
				draft.data = action.payload.data;
				break;
			}
			case Types.CONSULTA_CONSUMIDOR_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.CONSULTA_CONSUMIDOR_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				break;
			}

			default:
		}
		return draft;
	});
}
